import { apiGetRequest } from 'utilities/http/api/apiHttp';

export const apiSystemSettings = {
  getLeashSequenceActive: () =>
    apiGetRequest<{ value: number }>('system/setting/leash-sequences-active'),
  getLocalDeliveryAndHubPassThruActive: () =>
    apiGetRequest<{ value: number }>(
      'system/setting/local-delivery-and-hub-pass-thru-active',
    ),
};
